import React, { useEffect, useState } from 'react';
import ReactQuill from "react-quill";
import { Helmet } from "react-helmet";
import ImageUploader from "quill-image-uploader";
import ImageResize from 'quill-image-resize';
import axios from '../utils/axios';
import "react-quill/dist/quill.snow.css";
import { getCookie } from '../utils/common';

import {
    POST_EDITOR_FONTS,
    POST_EDITOR_FONT_SIZES,
} from 'src/utils/constants';

import PostEditorCustomVideo from './PostEditorCustomVideo';
ReactQuill.Quill.register(PostEditorCustomVideo);

// Font và size
const fonts = POST_EDITOR_FONTS;
const fontSizes = POST_EDITOR_FONT_SIZES;

const Font = ReactQuill.Quill.import("attributors/style/font");
Font.whitelist = fonts;
ReactQuill.Quill.register(Font, true);

const Size = ReactQuill.Quill.import("attributors/style/size");
Size.whitelist = fontSizes;
ReactQuill.Quill.register(Size, true);

ReactQuill.Quill.register('modules/imageResize', ImageResize);
ReactQuill.Quill.register("modules/imageUploader", ImageUploader);

// ===========================
// Upload ảnh
const uploadImage = async (file) => {
    try {
        let token = getCookie('accessToken') || localStorage.getItem('accessToken');

        const formData = new FormData();
        formData.append("file", file);

        const response = await axios.post("/api/v1/uploadfile/file", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": `Bearer ${token}`
            },
        });

        return response.data?.fileUrl || "";
    } catch (error) {
        console.error("❌ Lỗi upload ảnh:", error);
        alert("Upload ảnh thất bại.");
        return "";
    }
};

// ===========================
// Upload video
const uploadVideo = async (file) => {
    try {
        let token = getCookie('accessToken') || localStorage.getItem('accessToken');

        const formData = new FormData();
        formData.append("file", file);

        const response = await axios.post("/api/v1/uploadfile/file", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": `Bearer ${token}`
            },
        });

        return response.data?.fileUrl || "";
    } catch (error) {
        console.error("❌ Lỗi upload video:", error);
        alert("Upload video thất bại.");
        return "";
    }
};

// ===========================
// Cấu hình Quill
const modules = {
    toolbar: {
        container: [
            [{ font: fonts }],
            [{ size: fontSizes }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link", "image", "video"],
            ["clean"],
        ],
        handlers: {
            video: function () {
                const input = document.createElement("input");
                input.setAttribute("type", "file");
                input.setAttribute("accept", "video/*");
                input.click();

                input.onchange = async () => {
                    const file = input.files[0];
                    if (file) {
                        const range = this.quill.getSelection();
                        const url = await uploadVideo(file);
                        if (url) {
                            // this.quill.insertEmbed(range.index, "video", url, "user");
                            this.quill.insertEmbed(range.index, "PostEditorCustomVideo", url, "user");
                        }
                    }
                };
            }
        }
    },
    imageUploader: {
        upload: uploadImage,
    },
    // imageResize: {
    //     parchment: ReactQuill.Quill.import("parchment"),
    //     modules: ["Resize", "DisplaySize", "Toolbar"],
    // },
};

const PostEditor = ({ onChange, initialContent }) => {
    const [content, setContent] = useState(initialContent || "");

    useEffect(() => {
        setContent(initialContent || "");
    }, [initialContent]);

    const handleChange = (value) => {
        setContent(value);
        if (onChange) onChange(value);
    };

    return (
        <>
            <Helmet>
                <style>{`
                    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
                    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
                        content: attr(data-value);
                    }

                    .ql-snow .ql-picker.ql-font .ql-picker-label::before,
                    .ql-snow .ql-picker.ql-font .ql-picker-item::before {
                        content: attr(data-value);
                    }

                    ${fontSizes.map((size) => `
                        .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="${size}"]::before {
                            content: "${parseInt(size)}pt";
                        }

                        .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="${size}"]::before {
                            content: "${parseInt(size)}pt";
                        }
                    `).join("\n")}

                    ${fonts.map((font) => `
                        .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="${font}"]::before {
                            content: "${font}";
                        }

                        .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="${font}"]::before {
                            content: "${font}";
                        }
                    `).join("\n")}

                    .ql-editor video {
                        max-width: 100%;
                        height: auto;
                        border-radius: 8px;
                        margin: 12px 0;
                    }
                `}</style>
            </Helmet>

            <ReactQuill
                value={content}
                onChange={handleChange}
                modules={modules}
                theme="snow"
            />
        </>
    );
};

export default PostEditor;